import { Group, Button, Box, Card } from 'components'
import { IconTrash } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { SelectedSkillStandard } from '../../../types'
import { SkillStandardBreadcrumb } from './SkillStandardBreadcrumb'

interface SkillStandardCardProps {
  item: SelectedSkillStandard
  onRemove: (id: string) => void
  showCyclesBadges?: boolean
  disabled?: boolean
}

export const SkillStandardCard = ({ item, onRemove, showCyclesBadges, disabled }: SkillStandardCardProps) => {
  const { t } = useTranslation()

  return (
    <Card
      shadow="sm"
      withBorder
      sx={(theme) => ({
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: theme.shadows.md,
        }
      })}
    >
      <Card.Section p="md">
        <Group position="apart" align="flex-start" noWrap spacing="md">
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <SkillStandardBreadcrumb
              item={item}
              showCyclesBadges={showCyclesBadges}
              fullBreadCrumb={true}
            />
          </Box>
          <Button
            variant="light"
            color="red"
            size="sm"
            leftIcon={<IconTrash size={16} />}
            onClick={() => onRemove(item.id)}
            disabled={disabled}
            sx={{ flexShrink: 0 }}
          >
            {t('general_buttons_remove')}
          </Button>
        </Group>
      </Card.Section>
    </Card>
  )
}
